
import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import QrCodeReader from "@/components/QrCodeReader.vue";
import {Getter} from "vuex-class";
import router from "@/router";
import KeyBookedModal from "@/components/keys/KeyBookedModal.vue";

@Component({
    components: {
        QrCodeReader,
        KeyBookedModal,
    },
})
export default class KeyDropAgency extends Vue {

    get relay(): any {
        return this.currentKey?.Relays?.find((r) => r.type === "AGENCY");
    }

    get currentLocation() {
        return this.currentKey?.KeyLocation?.find((kL) => !kL.endDate)?.Location;
    }

    get reservedLocation() {
        return this.currentKey?.ReservedLocations?.[0];
    }

    get locationToScan() {
        return this.currentKey
          ? this.currentKey.currentLocation || this.reservedLocation
          : this.subObjects?.[0]?.currentLocation;
    }

    get lang(): string {
        return this.$root.$i18n.locale;
    }

    get displayConfirm() {
        const newTags: boolean = this.mapIds(this.currentKey?.Tags)?.
            some((tagId) => !this.mapIds(this.oldTags)?.includes(tagId));
        const removedTags: boolean = this.mapIds(this.oldTags)?.
            some((tagId) => !this.mapIds(this.currentKey?.Tags)?.includes(tagId));
        return newTags || removedTags;
    }

    get subObjectWithSameStatus(): any[] {
        return this.subObjects.filter((ck: any) => {
            let sameHolder: boolean;
            try {
                sameHolder = ck.KeyHolding[0].User.id === this.currentKey.KeyHolding[0].User.id;
            } catch (err) {
                sameHolder = false;
            }
            return (this.currentKey.status === ck.status) && (sameHolder || ck.status === "CREATED");
        });
    }

    get isManager(): boolean {
      return !!this.currentKey?.legitimateKeyAccess?.keyManagementId;
    }

    @Prop({default: () => ({})})
    public currentKey: any;

    @Prop({default: () => ({})})
    public currentKeyGroup: any;

    @Prop({default: () => []})
    public subObjects: any[];

    @Prop({default: false})
    public disabled: boolean;

    @Prop({default: false})
    public listView: boolean;

    @Getter private currentUser: any;
    @Getter private isAdmin: boolean;
    @Getter private isMobile: boolean;
    @Getter private canDoInEnvCompany: (right: string) => boolean;
    @Getter private isBookedKeyAvailable: (key: any) => boolean;

    private displayAdminConfirmation: boolean = false;
    private displayQrCodeReader: boolean = false;
    private loadingQrCodeStreamer: boolean = false;
    private displayTagAddition: boolean = false;
    private loadingDropQuery: boolean = false;
    private token: string = "";
    private qrCodeReaderError: any = null;
    private searchTags: string = null;
    private tags: any = [];
    private oldTags: any = [];
    private skipped: boolean = false;
    private showBooked: boolean = false;
    private canDropAgency: boolean = false;


    private  canAddTagAtDrop: boolean = false;
    private  displayDropRelayBtn: boolean = false;

    @Watch("currentKey")
    public handlerKeyChange(newValue, oldValue) {
      if (newValue?.Tags) {
        this.oldTags = [...newValue?.Tags];
      }
      if (newValue && (newValue.id !== oldValue?.id)) {
        this.fetchRelayOptions();
      }
    }

    @Watch("currentKey.status")
    public handlerKeyStatusChange(newValue, oldValue) {
      if (newValue && (newValue !== oldValue)) {
        this.fetchCanDoAction();
      }
    }

    private mounted(): void {
        if (this.currentKey?.Tags) {
            this.oldTags = [...this.currentKey?.Tags];
        }
        if (this.currentKey) {
          this.fetchRelayOptions();
          this.fetchCanDoAction();
        }
    }

    private async fetchRelayOptions() {
      if (this.relay) {
        this.canAddTagAtDrop = await this.$store.dispatch("options/readOptionValueByRelay", {
          relayId: this.relay.id,
          optionTypeLabel: "canAddTagAtDrop",
        });
        this.displayDropRelayBtn = await this.$store.dispatch("options/readOptionValueByRelay", {
          relayId: this.relay.id,
          optionTypeLabel: "displayDropRelayBtn",
        });
      }
    }

    private async fetchCanDoAction() {
      if (this.currentKey.status !== "IN_RELAY") {
        this.$store.dispatch("keys/canDoActions", {
          id: this.currentKey.id,
          actions: [{ type: "CAN_DROP_AGENCY" }],
        }).then((actions) => this.canDropAgency = actions?.[0]?.status);
      } else {
        this.canDropAgency = false;
      }
    }

    private mapIds = (array) => array?.map((item) => item.id) || [];

    private removeDuplicates(completeList, duplicates): any[] | null {
        if (!completeList || !duplicates) {
            return null;
        }
        return completeList.filter(
            (item: any) =>
                !duplicates.map((elem: any) => elem?.id)?.includes(item?.id),
        );
    }

    private remove(list, item): void {
        const pos = list.map((u) => u.id).indexOf(item.id);
        list.splice(pos, 1);
    }

    private getTags(): void {
        this.$store
            .dispatch("tags/getAll", {
                query: {
                    search: this.searchTags,
                    lang: this.lang,
                },
            })
            .then((res) => {
                this.tags = res;
            });
    }

    private readQRCode(params: {token: string, moveAllSubObjects?: boolean}): Promise<any> {
        const {token, moveAllSubObjects} = params;
        this.token = token;
        this.qrCodeReaderError = null;
        this.loadingQrCodeStreamer = true;
        const status: string = this.currentKey.status;
        return this.$store.dispatch(this.currentKeyGroup?.id ? "keyGroups/drop" : "locations/qrCodeVerification", {
            token,
            keyId: this.currentKey?.id,
            keyGroupId: this.currentKeyGroup?.id,
            dropFromRelay: !!this.currentKeyGroup?.id,
            keyStatus: status,
            moveAllSubObjects: !!this.currentKeyGroup?.id || moveAllSubObjects,
        }).then((res) => {
            if (res.dropped) {
                if (!this.skipped) {
                    this.updateKeyTags();
                }
                this.successCallback(res);
            } else {
                this.qrCodeReaderError = this.$i18n.t("alerts.error." + res.errorMessage || "default");
            }
        }).catch((err) => {
            const error = err?.response?.data?.error
              || err?.response?.data?.message
              || err?.response?.data?.name
              || "qrCodeNotFound";
            this.qrCodeReaderError = this.$i18n.t(`alerts.error.${error}`);
        }).finally(() => {
            this.loadingQrCodeStreamer = false;
        });
    }

    private resetQrCodeReader(): void {
        this.qrCodeReaderError = null;
        this.displayQrCodeReader = false;
    }

    private beforeDestroy() {
        this.resetQrCodeReader();
    }

    private dropKey(referent: any) {
        this.loadingDropQuery = true;
        if (!this.skipped) {
             this.updateKeyTags();
        }
        this.$store.dispatch("keys/drop", {
            keyId: this.currentKey.id,
            token: this.token,
            referentId: this.isAdmin ? this.currentUser.id : referent.id,
            relayId: this.relay.id,
            holderId: this.isAdmin ? this.currentKey.KeyHolding[0]?.userId : null,
        })
            .then(this.successCallback)
            .catch(this.failureCallback)
            .finally(() => { this.loadingDropQuery = false; });
    }

    private updateKeyTags() {
        return this.$store
            .dispatch("keys/updateById", {
                id: this.currentKey.id,
                data: {
                  ...this.currentKey,
                  newTags: this.currentKey.Tags,
                  Tags: this.mapIds(this.currentKey.Tags),
                },
            });
    }

    // if user skips adding tags , updating tags method won't be called
    private skip(skipped: boolean) {
        this.displayTagAddition = false;
        if (this.isAdmin) {
          this.displayAdminConfirmation = true;
        } else {
          this.displayQrCodeReader = true;
        }
        this.skipped = skipped;
    }

    private successCallback(res: any): void {
        if (res.keysNotMoved?.length > 0) {
            this.$store.commit("alerts/displayWarning", {
                msg: `${this.$i18n?.t("alerts.error.cannotMoveObject", {
                    objects: res.keysNotMoved.map((el) => el?.name).join(", "),
                })}`,
            });
        } else {
            this.$store.commit("alerts/displaySuccess", {
                icon: "icon-picto_depot-agence",
                msg: this.$i18n?.t("alerts.key.dropSuccess", {
                    key: this.currentKey?.name || this.currentKeyGroup?.name,
                    relay: this.relay?.name,
                }),
            });
        }
        this.dropKeyDone();
    }

    private failureCallback(error?: any): void {
        this.$store.commit("alerts/displayHttpError", {
          error,
          icon: "icon-picto_depot-agence",
        });
        this.dropKeyDone();
    }

    private dropKeyDone() {
        this.displayQrCodeReader = false;
        this.$store.dispatch("context/clearContext");
        if (this.isManager || this.isMobile || this.listView || !!this.currentKeyGroup?.id) {
            this.$emit("reset");
        } else {
            router.push({name: "keys"});
        }
    }

    private close() {
      this.resetQrCodeReader();
      this.displayAdminConfirmation = false;
    }

    private buttonClick(): void {
        if (!this.isBookedKeyAvailable(this.currentKey)) {
            this.showBooked = true;
        } else {
            this.nextStep();
        }
    }

    private nextStep(): void {
        if (this.canAddTagAtDrop && this.canDoInEnvCompany("EDIT_KEY_TAGS")) {
            this.getTags();
            this.displayTagAddition = true;
        } else {
            this.skip(true);
        }
    }

    private closeModal(): void {
        this.showBooked = false;
    }

}
